import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { AddDeliveryZoneRequestBody } from "./addDeliveryZone.types";

export const requestAddDeliveryZone = async (
  body: AddDeliveryZoneRequestBody
): Promise<void> => {
  return await instance.post(ApiRoutesDeliveryFees.DeliveryZone, body);
};
